// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SNA24_wrapper__3ZL2G","content":"SNA24_content__3dxmp","controls":"SNA24_controls__1q6AZ"};